var map = {
	"./err.svg": "9550",
	"./errorr.svg": "0217",
	"./no-ready.svg": "8d16",
	"./partsucces.svg": "00c1",
	"./succes.svg": "3cd8",
	"./wait-imports.svg": "190a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f41f";